import { ServiceNameType } from '@consigli/types';

/**
 * Project IDs that have access to the new Bid Review flow, keyed by the
 * webapp URL so the gate works across environments without a runtime flag
 * service.
 *
 * Add a project ID here to unlock the "Bid Review" service card for it.
 * All other projects will only see the legacy "Offer" card.
 */
const BID_REVIEW_PROJECT_IDS: Record<string, number[]> = {
  // Local dev
  'http://localhost:3000': [1000027],
  // Dev
  'https://app.dev.ai4eng.aecom.team': [1000027],
  // Prod
  'https://app.ai4eng.aecom.services': [100573],
};

const WEBAPP_URL = (import.meta.env.VITE_WEBAPP_URL ?? '').replace(/\/$/, '');

const allowedProjectIds = BID_REVIEW_PROJECT_IDS[WEBAPP_URL];

export function isBidReviewEnabledForProject(projectId: number): boolean {
  if (allowedProjectIds === undefined) return false;
  if (allowedProjectIds.length === 0) return true;
  return allowedProjectIds.includes(projectId);
}

export function filterBidReviewService<T extends { serviceName: string }>(
  services: T[],
  projectId: number,
): T[] {
  if (isBidReviewEnabledForProject(projectId)) {
    return services.filter((service) => service.serviceName !== ServiceNameType.OFFER);
  }
  return services.filter((service) => service.serviceName !== ServiceNameType.BID_REVIEW);
}
